import React from "react";
import { Document, Page, Text, View, StyleSheet,Image } from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";

const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 12,
    fontFamily: "Helvetica",
    color: "#101828",
  },
  heading: {
    textAlign: "center",
    fontSize: 18,
    fontWeight: "bold",
    marginBottom: 20,
    color: "#003149",
  },
  recordGroup: {
    marginBottom: 12,
    paddingBottom: 8,
    borderBottomWidth: 1,
    borderBottomColor: "#ccc",
    borderBottomStyle: "solid",
  },
  row: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 8,
  },
  label: {
    color: "#344054",
    fontWeight: "bold",
  },
  value: {
    color: "#101828",
  },
});

const ExportExpensesPDF = ({ data,logo }) => {
  const { t } = useTranslation();

  return (
    <Document>
      <Page size="A4" style={styles.page}>
    {logo && (
          <Image
            src={logo}
            style={{ width: 120, alignSelf: "center", marginBottom: 10 }}
          />
        )}
        <Text style={styles.heading}>
           {t("reimbursementRequest.heading")}
        </Text>

        {data.map((item, index) => (
          <View key={index} style={styles.recordGroup}>

            <View style={styles.row}>
              <Text style={styles.label}>{t("reimbursementRequest.tableHeaders.id")}:</Text>
              <Text style={styles.value}>{item.id}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("reimbursementRequest.tableHeaders.workerName")}:</Text>
              <Text style={styles.value}>{item.worker}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("reimbursementRequest.tableHeaders.amount")}:</Text>
              <Text style={styles.value}>{item.amount}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("reimbursementRequest.tableHeaders.dateOfExpense")}:</Text>
              <Text style={styles.value}>{item.date}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("reimbursementRequest.tableHeaders.description")}:</Text>
              <Text style={styles.value}>{item.description}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("reimbursementRequest.tableHeaders.proof")}:</Text>
              <Text style={styles.value}>{item.proof}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("reimbursementRequest.tableHeaders.status")}:</Text>
              <Text style={styles.value}>{item.status}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("reimbursementRequest.tableHeaders.comments")}:</Text>
              <Text style={styles.value}>{item.comments}</Text>
            </View>

          </View>
        ))}

      </Page>
    </Document>
  );
};

export default ExportExpensesPDF;
